export enum AddressVerificationStatus {
    UseSuggested = 1,
    UseAsEntered = 2
}